var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeatmap = function SvgHeatmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm0 1.217a8.283 8.283 0 1 0 0 16.566 8.283 8.283 0 0 0 0-16.566zm2.2 10.95a1.404 1.404 0 1 1 0 2.808 1.404 1.404 0 0 1 0-2.808zm-5.616-.935a1.404 1.404 0 1 1 0 2.807 1.404 1.404 0 0 1 0-2.807zm3.276-1.872a.936.936 0 1 1 0 1.872.936.936 0 0 1 0-1.872zm2.807-4.68a1.872 1.872 0 1 1 0 3.744 1.872 1.872 0 0 1 0-3.744zm-6.551.936a.936.936 0 1 1 0 1.872.936.936 0 0 1 0-1.872z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgHeatmap;